import { useEffect } from 'react';
import {
  NOT_FOUND_DESCRIPTION,
  NOT_FOUND_ROBOTS,
  NOT_FOUND_SEO_ATTR,
  NOT_FOUND_TITLE,
} from './notFoundSeo';

function getOrCreateOwnedDescription() {
  const owned = document.head.querySelector(
    `meta[name="description"][${NOT_FOUND_SEO_ATTR}="description"]`
  );
  if (owned) return { node: owned, created: false, adopted: false };

  const existing = document.head.querySelector('meta[name="description"]');
  if (existing) {
    existing.setAttribute(NOT_FOUND_SEO_ATTR, 'description');
    return { node: existing, created: false, adopted: true };
  }

  const node = document.createElement('meta');
  node.setAttribute('name', 'description');
  node.setAttribute(NOT_FOUND_SEO_ATTR, 'description');
  document.head.appendChild(node);
  return { node, created: true, adopted: false };
}

function getOrCreateOwnedRobots() {
  const owned = document.head.querySelector(
    `meta[name="robots"][${NOT_FOUND_SEO_ATTR}="robots"]`
  );
  if (owned) return { node: owned, created: false };

  const node = document.createElement('meta');
  node.setAttribute('name', 'robots');
  node.setAttribute(NOT_FOUND_SEO_ATTR, 'robots');
  document.head.appendChild(node);
  return { node, created: true };
}

export function useNotFoundSeo() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = NOT_FOUND_TITLE;

    const {
      node: description,
      created: createdDescription,
    } = getOrCreateOwnedDescription();
    const previousDescription = description.getAttribute('content');
    description.setAttribute('content', NOT_FOUND_DESCRIPTION);

    const { node: robots, created: createdRobots } = getOrCreateOwnedRobots();
    robots.setAttribute('content', NOT_FOUND_ROBOTS);

    return () => {
      document.title = previousTitle;

      if (createdDescription) {
        description.remove();
      } else if (document.head.contains(description)) {
        description.removeAttribute(NOT_FOUND_SEO_ATTR);
        if (previousDescription != null) {
          description.setAttribute('content', previousDescription);
        } else {
          description.removeAttribute('content');
        }
      }

      if (createdRobots) {
        robots.remove();
      } else if (document.head.contains(robots)) {
        document.head
          .querySelector(`meta[name="robots"][${NOT_FOUND_SEO_ATTR}="robots"]`)
          ?.remove();
      }
    };
  }, []);
}
